import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SUB_MODULE } from "../apiRoutes";

// Note: API path for modules list per swagger is /v1/master-data/module/
// We infer base by replacing trailing 'module/sub/' with 'module/' from SUB_MODULE const
const MODULES_ENDPOINT = SUB_MODULE.replace(/module\/sub\/$/, "module/");

export interface ModuleItem {
  id: string;
  name: string;
}

export interface ModulesResponse {
  data: {
    records: ModuleItem[];
  }[];
}

const fetchModules = async () => {
  const response = await axiosAuth.get(MODULES_ENDPOINT, {});
  return response.data as ModulesResponse;
};

export const useGetModules = (
  queryParams?: UseQueryOptions<ModulesResponse, Error, ModulesResponse, [string]>
) =>
  useQuery<ModulesResponse, Error, ModulesResponse, [string]>({
    queryKey: ["modules-list"],
    queryFn: fetchModules,
    ...(queryParams as any),
  });


